export default __webpack_public_path__ + "static/media/mt5_android.42d0568a.png";